import React, { useMemo } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { LazyImage } from '@bingads-webui-react/lazy-image';
import { keyCode } from '@bingads-webui/keycode';
import { ImageItemModelShape } from './item-model-shape';
import { emptyButtonStyle } from './styles/shared-styles';

const ImageListItem = (props) => {
  const onItemClicked = (clickEvent) => {
    if (clickEvent.currentTarget && clickEvent.currentTarget.id) {
      props.onItemClicked(clickEvent.currentTarget.id, props.index);
    }
  };

  const thumbnailHeight = props.itemHeight;
  const thumbnailWidth = Math.round((props.image.width * thumbnailHeight) / props.image.height);
  const limitedThumbnailWidth =
    thumbnailWidth / thumbnailHeight > 1.6 ? thumbnailHeight * 1.6 : thumbnailWidth;
  const nagativeLeftMargin = -(thumbnailWidth - limitedThumbnailWidth) / 2;

  const onKeyDown = (event) => {
    if (event.keyCode === keyCode.Escape) {
      props.onEscapeFromImage(event);
    }
  };

  const imageEl = useMemo(() => {
    if (props.isOriginRatioUsed) {
      return (
        <img
          src={props.image.src}
          height={props.itemHeight}
          style={{
            marginLeft: `${nagativeLeftMargin}px`,
          }}
          alt={props.image.altText}
        />
      );
    }
    return (
      <img
        src={props.image.src}
        width={thumbnailWidth}
        style={{
          marginLeft: `${nagativeLeftMargin}px`,
        }}
        alt={props.image.altText}
      />
    );
  }, [nagativeLeftMargin, props.image.altText, props.image.src,
    props.isOriginRatioUsed, props.itemHeight, thumbnailWidth]);

  return (
    <button
      onClick={onItemClicked}
      id={props.image.id}
      style={emptyButtonStyle}
      height={thumbnailHeight}
      width={props.isOriginRatioUsed ? undefined : limitedThumbnailWidth}
      aria-label={props.ariaLabel}
      ref={props.itemRef}
      onKeyDown={onKeyDown}
    >
      {
        props.isLazyLoadEnabled &&
        <LazyImage
          src={props.image.src}
          height={thumbnailHeight}
          width={thumbnailWidth}
          limitWidth={limitedThumbnailWidth}
          alt={props.image.altText}
          imagePlaceHolder={props.imagePlaceHolder}
          onImageLoadError={props.onImageLoadError}
        />
      }
      {
        !props.isLazyLoadEnabled && imageEl
      }
    </button>
  );
};

ImageListItem.propTypes = {
  image: ImageItemModelShape.isRequired,
  onItemClicked: PropTypes.func,
  onImageLoadError: PropTypes.func,
  onEscapeFromImage: PropTypes.func,
  itemHeight: PropTypes.number,
  isOriginRatioUsed: PropTypes.bool,
  imagePlaceHolder: PropTypes.func,
  isLazyLoadEnabled: PropTypes.bool,
  index: PropTypes.number,
  ariaLabel: PropTypes.string.isRequired,
  itemRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]).isRequired,
};

ImageListItem.defaultProps = {
  onItemClicked: _.noop,
  onImageLoadError: _.noop,
  onEscapeFromImage: _.noop,
  itemHeight: 250,
  isOriginRatioUsed: false,
  imagePlaceHolder: null,
  isLazyLoadEnabled: true,
  index: null,
};

export { ImageListItem };
